function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { css } from 'styled-components';
import get from 'lodash.get';

var getFromTheme = function getFromTheme(props) {
  return function (spec) {
    var matchedSpec = props.theme.yoga[spec];
    return matchedSpec;
  };
};

var getSpacing = function getSpacing(props) {
  return getFromTheme(props)('spacing');
};

var getBorder = function getBorder(props) {
  return getFromTheme(props)('borders');
};

var getBorderRadius = function getBorderRadius(props) {
  return getFromTheme(props)('radii');
};

var getColor = function getColor(props) {
  return getFromTheme(props)('colors');
};

var getFontSize = function getFontSize(props) {
  return getFromTheme(props)('fontSizes');
};

var getFontWeight = function getFontWeight(props) {
  return getFromTheme(props)('fontWeights');
};

var getLineHeight = function getLineHeight(props) {
  return getFromTheme(props)('lineHeights');
};

var getElevation = function getElevation(props) {
  return getFromTheme(props)('elevations');
};

var generator = function generator(_ref) {
  var componentProps = _ref.props,
      prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      _ref$getter = _ref.getter,
      getter = _ref$getter === void 0 ? function () {
    return {};
  } : _ref$getter,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? function (value) {
    return value;
  } : _ref$transform;
  var themeProp = getter(componentProps); // If prop is an array, ex: ['border', 'b'], we run the generator for each one

  if (Array.isArray(prop)) {
    return prop.map(function (p) {
      return generator({
        props: componentProps,
        prop: p,
        cssProperty: cssProperty,
        getter: getter,
        transform: transform
      });
    }).flat();
  } // Getting the desired prop from your component props


  var propFromComponent = componentProps[prop]; // Getting the value from the theme

  var value = get(themeProp, propFromComponent, propFromComponent);
  var transformedValue = transform(value); // If the css is an array, like ['marginLeft', 'marginRight'], we produce
  // an object mapping all of values to its keys

  if (Array.isArray(cssProperty)) {
    var computedCSS = cssProperty.reduce(function (acc, property) {
      return Object.assign(acc, _defineProperty({}, property, transformedValue));
    }, {});
    return css(computedCSS);
  }

  return css(_defineProperty({}, cssProperty, transformedValue));
};

var compose = function compose() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function (args) {
    return functions.map(function (fn) {
      return fn(args);
    }).flat().filter(Boolean);
  };
};

export { getFromTheme, getSpacing, getBorder, getColor, getBorderRadius, getFontSize, getFontWeight, getLineHeight, getElevation, generator, compose };